import React from 'react';
import "./Admin.css"
const AdminCheckBox = ({ name, checked, onChange, id, value, type, className, ...rest }) => {
    return (
        <label className="admin-checkbox">
            <input
                name={name}
                type={type ? type : 'checkbox'}
                checked={checked}
                id={id}
                data-test-id={id || name}
                value={value}
                onChange={onChange}
                className={`r-input ${className}`}
                {...rest}
            />
        </label>
    );
};

export default AdminCheckBox;
